import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'redux-router';
import { apiStatuses } from '../actions/Actions';
import {
  IAddress,
  IProductInfo,
  IReduxRouterAction,
  IReferer,
  ISessionInfo,
  IState,
  IUserInfo
} from '../CustomTypes';
import { Button } from '../input-components/InputComponents';
import { sccPulseTrackPageView } from '../PulseUtils';

export interface IProps {
  __rct: string;
  fetchUserInfo: IUserInfo;
  push: IReduxRouterAction;
  productInfo: IProductInfo;
  address: IAddress;
  sessionInfo: ISessionInfo;
  referer: IReferer;
  userInfo: IUserInfo;
}
export class YesPlease extends React.Component<IProps, {}> {
  constructor() {
    super();
    this.nextStep = this.nextStep.bind(this);
    this.state = { showLoyaltyError: false };
  }

  public render() {
    return (
      <div>
        <Button className="yesplease orderbutton" onClick={this.nextStep}>
          {this.props.productInfo.orderButtonText || 'Bestill'}
        </Button>
      </div>
    );
  }

  private nextStep() {
    const { productInfo, fetchUserInfo, userInfo } = this.props;
    const { redirectUri, referer } = this.props.referer;
    if (productInfo.loyaltyPartner && !userInfo.valid) {
      return;
    }
    const redirectParams =
      redirectUri || referer || this.props.__rct
        ? `redirectUri=${encodeURIComponent(
            redirectUri
          )}&referer=${encodeURIComponent(referer)}&__rct=${this.props.__rct}`
        : '';
    sccPulseTrackPageView(productInfo, {}, 'Buy button clicked');

    if (
      ![productInfo, fetchUserInfo]
        .map(s => s.apiStatus)
        .find(s => s !== apiStatuses.SUCCESS)
    ) {
      if (!productInfo.pureDigital) {
        if (this.props.address.zipCode && this.props.address.city) {
          this.props.push(
            `/products/${
              this.props.productInfo.productId
            }/userinfo?${redirectParams}`
          );
        } else {
          this.props.push(
            `/products/${
              this.props.productInfo.productId
            }/address?${redirectParams}`
          );
        }
      } else {
        const { productId } = this.props.productInfo;
        this.props.push(
          `/products/${productId}/selectpaymentmethod?${redirectParams}`
        );
      }
    } else {
      this.props.push(
        `/products/${
          this.props.productInfo.productId
        }/usersearch?${redirectParams}`
      );
    }
  }
}

export default connect(
  (state: IState) => ({
    __rct: state.router.location.query.__rct,
    address: state.address,
    fetchUserInfo: state.fetchUserInfo,
    productInfo: state.productInfo,
    referer: state.referer,
    sessionInfo: state.sessionInfo,
    userInfo: state.userInfo
  }),
  dispatch => bindActionCreators({ push }, dispatch)
)(YesPlease);



// WEBPACK FOOTER //
// ./src/input-components/YesPlease.tsx